import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4095b7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center md:block md:p-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_3 = { class: "inline-block bg-white rounded-lg border border-gray-400 p-4 text-left overflow-hidden shadow-lg w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverOverlay = _resolveComponent("PopoverOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_BuyPanel = _resolveComponent("BuyPanel")!
  const _component_SellPanel = _resolveComponent("SellPanel")!
  const _component_ShipPanel = _resolveComponent("ShipPanel")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.isOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Popover, {
        as: "div",
        class: "absolute z-10 inset-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-100",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-100",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PopoverOverlay, {
                  onClick: _ctx.closeOverlay,
                  class: "relative"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createElementVNode("div", {
                      style: _normalizeStyle(_ctx.bgBounds),
                      class: "absolute bg-transparent bg-opacity-75"
                    }, null, 4)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-100",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-100",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.overlayBounds),
                  class: "md:absolute transform transition-all w-full"
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.innerBounds),
                    class: "inline-block md:absolute w-full md:w-96"
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle(_ctx.triangleBounds),
                      class: "triangle hidden md:block"
                    }, null, 4),
                    _createElementVNode("div", _hoisted_3, [
                      (_ctx.panelType === 'BuyPanel')
                        ? (_openBlock(), _createBlock(_component_BuyPanel, {
                            key: 0,
                            onClose: _ctx.closeOverlay,
                            data: _ctx.panelData
                          }, null, 8, ["onClose", "data"]))
                        : (_ctx.panelType === 'SellPanel')
                          ? (_openBlock(), _createBlock(_component_SellPanel, {
                              key: 1,
                              onClose: _ctx.closeOverlay,
                              data: _ctx.panelData
                            }, null, 8, ["onClose", "data"]))
                          : (_ctx.panelType === 'ShipPanel')
                            ? (_openBlock(), _createBlock(_component_ShipPanel, {
                                key: 2,
                                onClose: _ctx.closeOverlay,
                                data: _ctx.panelData
                              }, null, 8, ["onClose", "data"]))
                            : _createCommentVNode("", true)
                    ])
                  ], 4)
                ], 4)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}